"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var customProps = {
  /* fonts */
  "--font-regular": " 'TelefonicaRegular'",
  "--font-light": "'TelefonicaLight'",
  "--font-bold": "'TelefonicaBold' ",
  "--font-thin": "'TelefonicaThin' ",
  "--font-hand": "'TelefonicaHand' ",

  /* basic colors */
  "--color-blue": "#019BCE",
  "--color-blue1": "#00A9E0",
  "--color-blue2": "#32B1E2",
  "--color-blue3": "#27A4D5",
  "--color-red": "#D23C31",
  "--color-red1": "#DF766E",
  "--color-red2": "#9E0707",
  "--color-grey0": "#FAFAFA",
  "--color-grey1": "#E9EAE8",
  "--color-grey2": "#D3D4D3",
  "--color-grey3": "#B6B7B7",
  "--color-grey4": "#86888C",
  "--color-grey5": "#50535A",
  "--color-grey6": "#C6C6C6",
  "--color-green": "#5BC500",
  "--color-green1": "#7BB900",
  "--color-green2": "#4CAF50",
  "--color-white": "#FFFFFF",
  "--color-purple": "#954B97",
  "--color-purple2": "#990066",
  "--color-magenta": "#E9426D",
  "--color-orange": "#EC6839",
  "--color-orange-light": "#f59c00",
  "--color-mustard": "#D6B534",
  "--color-black": "#000000",
  "--color-black1": "#231F20",

  /* Colores accesibles */
  "--color-blue-a": "#009BCE",
  "--color-green-a": "#4EA800",
  "--color-orange-a": "#EC6838",
  "--color-yellow-a": "#CC8200",

  /* Colores de Movistar+ */
  "--color-futbol": "#00DC91",
  "--color-series": "#FF8C1E",
  "--color-cine": "#D23C31",
  "--color-seldeportes": "#5BC500",
  "--color-motor": "#5BC500",
  "--color-infantil": "#F03C87"
};
var _default = customProps;
exports.default = _default;

//# sourceMappingURL=index.js.map